// extracted by mini-css-extract-plugin
module.exports = {"unverifiedWrapper":"vendor_unverifiedWrapper__Zf4cs","unverifiedTextBlock":"vendor_unverifiedTextBlock__21KMW"};